<div class="not-authorized-container"
     fxLayout="column"
     fxLayoutAlign="center center">
    <div class="not-authorized-container-content">
        <h3>
            <span class="fa fa-exclamation-triangle not-authorized-container-content-error-icon"></span>
            No Authorization
        </h3>
        <div>
            <p>We're sorry, you are not authorized to use this application.</p>
            <p>Please contact the Help Desk at
                <br/>800-755-2728 or
                <a href="mailto:LTLCCG@xpo.com" class="not-authorized-container-content-email">LTLCCG@xpo.com</a>
            </p>
        </div>
    </div>
</div>